import { baseApi } from "../baseApi";

export const grnApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
    postGrnOrder: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_grn_list`,
        method:'post',
        body:data
      })
    }),
    postCreateGrn: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.save_grn`,
        method:'post',
        body:data
      })
    }),
    postUpdateGrn: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.update_grn`,
        method:'post',
        body:data
      })
    }),
    postSubmitGrn: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.submit_grn`,
        method:'post',
        body:data
      })
    }),
    getCreateGrnDetail: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_create_grn_details`,
        method:'post',
        body:data
      })
    }),
  }),
});

export const { usePostGrnOrderMutation,useGetCreateGrnDetailMutation,usePostCreateGrnMutation,usePostSubmitGrnMutation,usePostUpdateGrnMutation } = grnApi;
